document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('shipping-estimator-form');
  if (!form) return;

  const results = document.getElementById('shipping-estimator-results');

  function formatMoney(amount) {
    return parseFloat(amount).toLocaleString('it-IT', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    results.innerHTML = '<p>Calcolo in corso…</p>';

    const country = document.getElementById('shipping_country').value;
    const zip = document.getElementById('shipping_zip').value;
    const province = document.getElementById('shipping_province')?.value || '';

    await fetch('/cart.js'); // sync cart

    const params = new URLSearchParams({
      'shipping_address[country]': country,
      'shipping_address[zip]': zip,
      _: Date.now()
    });

    if (province.trim() !== '') {
      params.append('shipping_address[province]', province.trim());
    }

    try {
      const response = await fetch(`/cart/shipping_rates.json?${params.toString()}`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      });

      const data = await response.json();

      if (!data.shipping_rates || data.shipping_rates.length === 0) {
        results.innerHTML = '<p>Nessuna tariffa trovata per questo indirizzo.</p>';
        return;
      }

      results.innerHTML = data.shipping_rates
        .map(rate => {
          const price = formatMoney(rate.price); // ← CORRETTO
          return `<div class="shipping-rate"><strong>${rate.name}</strong>: ${price}</div>`;
        })
        .join('');

    } catch (err) {
      console.error(err);
      results.innerHTML = '<p>Errore durante il calcolo. Riprova.</p>';
    }
  });
});
